import { forwardRef } from "react";

import { observer } from "mobx-react";

import { BasicInput, BasicInputProps } from "../BasicInput";

export interface EmailInputProps extends BasicInputProps {
  type: "email";
}

export const EmailInput = observer(
  forwardRef<HTMLInputElement, EmailInputProps>(function EmailInput(
    props,
    ref
  ) {
    return <BasicInput ref={ref} leftIcon="input-email" {...props} />;
  })
);
